var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23 3.58 5.078 12.21.323.776.837.067L42.42 17.69l-10.043 8.603-.638.547.195.816 3.068 12.864-11.285-6.893-.717-.438-.717.438-11.285 6.893 3.068-12.864.195-.816-.638-.547L3.58 17.69l13.182-1.057.837-.067.323-.775L23 3.58Z",
    stroke: "currentColor",
    strokeWidth: 2.75
  })));
};
export default SvgIconStar;